<template>
  <div>
    <div class="cpy_info">
      <el-table :data="contentData" border stripe style="width: 100%">
          <el-table-column >
              <template scope="scope">
                <div @click="clickToRouter(scope.row.id)">
                  <p>
                    {{scope.row.title}}
                    <span style="float:right;color:#c8c8c8">发布时间:{{scope.row.publishTime}}</span>
                  </p>

                </div>
              </template>
          </el-table-column>
      </el-table>
      <el-pagination @current-change="initData" :current-page.sync="currentPage" :page-size="pageSize" :total="totalData" layout="total, prev, pager, next"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
    data: function() {
        return {
          categoryList:[],
          contentData:[],

          currentCategoryId:this.$route.query.categoryId || 0,
          currentPage: 1,
          pageSize: 15,
          totalData: 0,
        }
    },
    created: function() {
      this.initData();
    },
    methods: {
      initData(){
        console.log(this.currentCategoryId);
        var self = this;
        var postData = {
            "pageSize": this.pageSize,
            "pageNo": this.currentPage,
            "params": {"published":1},
            "desc":["publishTime"]
        }

        this.$http.post(self.globalUrl.feePage, JSON.stringify(postData)).then(function(res) {
            if (res.data.code == 200000) {
                self.contentData = res.data.data.records;
                self.totalData = Number(res.data.data.total);
            }
        });

      },
      handlerCategory(id){
          this.currentCategoryId = id;
          this.initData();
      },
      clickToRouter(id){
        this.$router.push('/feeContent?contentId='+id);
      }

    }
}
</script>
<style media="screen" lang="less">

.cpy_info{
  margin-top: 2px;
}


.article{
  margin-top: 2px;
  height: 300px;

  &>ul.article-list{

    &>li{

      &>a.router-link-active{
          color   : #fff;
          background-color: #ff8a23;
      }
    }
  }
}




</style>



// WEBPACK FOOTER //
// feeList.vue?3fa53492